var map = {
	"./AI应用.png": "d23d",
	"./PV.png": "96b5",
	"./UV.png": "faf2",
	"./total.png": "c4c0",
	"./图像识别算法.png": "45d8",
	"./大模型算法.png": "c56a",
	"./数字人.png": "bea2",
	"./语音交互算法.png": "e097"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1450";